import { getWatchDogIcon } from "@/components/hlidaci-pes/watchdog-page/watchDogOverviewUtils";
import { Button } from "@/components/ui/Button";
import {
  getSelectionIconClassName,
  selectionCheckClassName,
  selectionRowClassName,
} from "@/components/ui/SelectionRowStyles";
import { useLanguage } from "@/context/LanguageContext";
import type { WatchDog } from "@/types";
import { getEstateValueLabel } from "@/utils/estateValueLabels";
import { CheckIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

export type WatchDogSelectorButtonProps = {
  watchDog: WatchDog;
  isActive: boolean;
  onClick: () => void;
};

export function WatchDogSelectorButton({
  watchDog,
  isActive,
  onClick,
}: WatchDogSelectorButtonProps) {
  const { language } = useLanguage();
  const copy = {
    cs: {
      noLocation: "Bez lokality",
    },
    en: {
      noLocation: "No location",
    },
  }[language];
  const Icon = getWatchDogIcon(watchDog.estateType);
  const offerTypeLabel = getEstateValueLabel(watchDog.offerType, language);
  const estateTypeLabel = getEstateValueLabel(watchDog.estateType, language);
  const locationLabel = getEstateValueLabel(
    watchDog.searchAddress || watchDog.exactAddress,
    language,
  );
  const detailsLabel = [offerTypeLabel, estateTypeLabel]
    .filter(Boolean)
    .join(" · ");

  return (
    <Button
      type="button"
      variant="unstyled"
      aria-pressed={isActive}
      data-active={isActive}
      onClick={onClick}
      className={selectionRowClassName}
    >
      <span className={getSelectionIconClassName(isActive)}>
        <Icon aria-hidden="true" className="size-4" />
      </span>

      <span className="min-w-0 flex-1">
        <span className="block truncate text-xs font-medium">
          {locationLabel || copy.noLocation}
        </span>
        <span className="block truncate text-[10px] text-foreground/45">
          {detailsLabel}
        </span>
      </span>

      {isActive ? (
        <span className={selectionCheckClassName}>
          <CheckIcon aria-hidden="true" className="size-4 stroke-[2.5]" />
        </span>
      ) : (
        <ChevronRightIcon
          aria-hidden="true"
          className="size-4 shrink-0 text-foreground/30 transition-transform group-hover:translate-x-0.5"
        />
      )}
    </Button>
  );
}
